export const map = {
    getGeocodeList: (address, language) => axios.get('https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyB2r8MstzOL8RZk8RhEWbBcszH2sAZ3LRU', { params: { address, language } }).then((res) => res.data.results),
}
